module.exports = __webpack_public_path__ + "img/44.78677882.jpg";